// extracted by mini-css-extract-plugin
module.exports = {"row":"EsXsJy7SMOCMhJ08ZScWe","productsList":"X7X0VXgIHCi2kn47aNocF"};